'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _svg = require('../../utils/svg.utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var controls = (0, _svg.getSvgControls)();
var Svg = controls.Svg,
    Path = controls.Path;

var CoffeeMachine = function (_React$Component) {
    _inherits(CoffeeMachine, _React$Component);

    function CoffeeMachine() {
        _classCallCheck(this, CoffeeMachine);

        return _possibleConstructorReturn(this, (CoffeeMachine.__proto__ || Object.getPrototypeOf(CoffeeMachine)).apply(this, arguments));
    }

    _createClass(CoffeeMachine, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                Svg,
                { width: '26', height: '32', viewBox: '0 0 26 32' },
                _react2.default.createElement(Path, { fill: this.props.fill,
                    d: 'M25.162 1.619h-19.626c-1.445 0-2.62 1.175-2.62 2.62v1.126c0 1.445 1.175 2.62 2.62 2.62h1.76v3.134h0.925v-3.134h1.849v3.134h0.925v-3.134h6.885v15.511h-14.502c-0.255 0-0.462 0.207-0.462 0.462v2.518h-2.453c-0.255 0-0.462 0.207-0.462 0.462v2.98c0 0.255 0.207 0.462 0.462 0.462h24.7c0.255 0 0.462-0.207 0.462-0.462v-22.393c0-0.001 0-0.002 0-0.003v-5.442c-0-0.255-0.207-0.462-0.463-0.462zM24.7 29.456h-23.775v-2.055h23.776v2.055zM24.7 26.476h-20.86v-2.055h20.86v2.055zM24.7 23.496h-5.896v-15.511h5.896v15.511zM24.7 7.061h-19.164c-0.935 0-1.696-0.761-1.696-1.696v-1.126c0-0.935 0.76-1.696 1.696-1.696h19.164v4.517z' }),
                _react2.default.createElement(Path, { fill: this.props.fill,
                    d: 'M13.299 18.31h0.346c1.387 0 2.516-1.129 2.516-2.516s-1.129-2.516-2.516-2.516h-8.611c-0.255 0-0.462 0.207-0.462 0.462v3.502c0 2.443 1.988 4.431 4.431 4.431 2.075 0 3.817-1.435 4.296-3.364zM13.433 17.243v-3.040h0.211c0.877 0 1.591 0.714 1.591 1.591s-0.714 1.591-1.591 1.591h-0.218c0.002-0.047 0.007-0.094 0.007-0.142zM5.496 17.243v-3.040h7.013v3.040c0 1.933-1.573 3.506-3.507 3.506s-3.506-1.573-3.506-3.506z' })
            );
        }
    }]);

    return CoffeeMachine;
}(_react2.default.Component);

CoffeeMachine.propTypes = {
    fill: _react2.default.PropTypes.string
};

exports.default = CoffeeMachine;


//////////////////
// WEBPACK FOOTER
// ./~/pluton-assets/lib/icons/svg/coffee-machine.js
// module id = 1088
// module chunks = 0